export const assetKeys={
  // dct
  description: "dct:description",
  title: "dct:title",
  license: "dct:license",
  identifier: "dct:identifier",
  admsIdentifier: "adms:identifier",
  alternative: "dct:alternative",
  publisher: "dct:publisher",
  dctCreator: "dct:creator",
  temporal: "dct:temporal",
  spatial: "dct:spatial",
  format: "dct:format",
  conformsTo: "dct:conformsTo",
  dctLanguage: "dct:language",
  modified: "dct:modified",
  // dcat
  keyword: "dcat:keyword",
  distributionMediaType: "dcat:mediaType",
  byteSize: "dcat:byteSize",
  version: "dcat:version",
  accessURL: "dcat:accessURL",
  downloadURL: "dcat:downloadURL",
  distribution: "dcat:distribution",
  startDate: "dcat:startDate",
  endDate: "dcat:endDate",
  packageFormat: "dcat:packageFormat",
  // dcatlds
  instructions: "dcatlds:instructions",
  finetuningMethodology: "dcatlds:finetuningMethodology",
  inputLanguage: "dcatlds:inputLanguage",
  outputLanguage: "dcatlds:outputLanguage",
  accessLevel: "dcatlds:accessLevel",
  amountOfActiveParameters: "dcatlds:amountOfActiveParameters",
  distributionMethod: "dcatlds:distributionMethod",
  tokensPerParameter: "dcatlds:tokensPerParameter",
  modelDistribution: "dcatlds:modelDistribution",
  // ms
  accessLocation: "ms:accessLocation",
  downloadLocation: "ms:downloadLocation",
  anonymized: "ms:anonymized",
  anonymizationDetails: "ms:anonymizationDetails",
  sensitiveDataDetails: "ms:sensitiveDataDetails",
  personalDataIncluded: "ms:personalDataIncluded",
  sensitiveDataIncluded: "ms:sensitiveDataIncluded",
  personalDataDetails: "ms:personalDataDetails",
  lrType: "ms:lrType",
  mediaType: "ms:mediaType",
  msfunction: "ms:function",
  processingResourceType: "ms:processingResourceType",
  outputResource: "ms:outputResource",
  inputContentResource: "ms:inputContentResource",
  processingResource: "ms:processingResource",
  languageDependent: "ms:languageDependent",
  softwareDistributionForm: "ms:softwareDistributionForm",
  softwareDistribution: "ms:softwareDistribution",
  executionLocation: "ms:executionLocation",
  language: "ms:language",
  requiresSoftware: "ms:requiresSoftware",
  languageCode: "ms:languageCode",
  languageVarietyName: "ms:languageVarietyName",
  region: "ms:region",
  script: "ms:script",
  variant: "ms:variant",
  citationText: "ms:citationText",
  hasOriginalSource: "ms:hasOriginalSource",
  originalSourceDescription: "ms:originalSourceDescription",
  pivotLanguage: "ms:pivotLanguage",
  targetLanguage: "ms:targetLanguage",
  metalanguage: "ms:metalanguage",
  sourceLanguage: "ms:sourceLanguage",
  cost: "ms:cost",
  amount: "ms:amount",
  currency: "ms:currency",
  size: "ms:size",
  sizeUnit: "ms:sizeUnit",
  multilingualityType: "ms:multilingualityType",
  corpusSubclass: "ms:corpusSubclass",
  lingualityType: "ms:lingualityType",
  lcrSubclass: "ms:lcrSubclass",
  linguisticInformation: "ms:linguisticInformation",
  domain: "ms:domain",
  iprHolder: "ms:iprHolder",
  isDocumentedBy: "ms:isDocumentedBy",
  annotationType: "ms:annotationType",
  dataProtectionPrincipleApplied: "ms:dataProtectionPrincipleApplied",
  variantOf: "ms:variantOf",
  finetuneDataset: "ms:finetuneDataset",
  evaluationDataset: "ms:evaluationDataset",
  quantized: "ms:quantized",
  quantizationProcess: "ms:quantizationProcess",
  parameterPrecision: "ms:parameterPrecision",
  modelType: "ms:modelType",
  modelFunction: "ms:modelFunction",
  evaluationResults: "ms:evaluationResults",
  creationDetails: "ms:creationDetails",
  contextLength: "ms:contextLength",
  // @it6
  trainedOn: "it6:trainedOn",
  trainingMethodologies: "it6:trainingMethodologies",
  trainingProcess: "it6:trainingProcess",
  limitations: "it6:limitations",
  bias: "it6:bias",
  measurementMethodology: "it6:measurementMethodology",
  hasInferencingImpact: "it6:hasInferencingImpact",
  hasTrainingImpact: "it6:hasTrainingImpact",
  powerConsumption: "it6:powerConsumption",
  hasOutputModality: "it6:hasOutputModality",
  intendedUse: "it6:intendedUse",
  releaseDate: "it6:releaseDate",
  hasOutputModality: "it6:hasOutputModality",
  hasInputModality: "it6:hasInputModality",
  intendedUse: "it6:intendedUse",
  releaseDate: "it6:releaseDate",
  designSpecifications: "it6:designSpecifications",
  hasBenchmark: "it6:hasBenchmark",
  // @dpv,
  hasTechnicalOrganisationalMeasure: "dpv:hasTechnicalOrganisationalMeasure",
  // @items
  id: "@id",
  type: "@type",
  value: "@value",
  languageElement: "@language",
  // foaf
  name: "foaf:name",
  document: "foaf:Document",

  schemaAgency: "adms:schemaAgency",
  notation: "skos:notation",
  // odrl
  hasPolicy: "odrl:hasPolicy",
  // xsd
  string: "xsd:string",
  uriType: "xsd:anyURI",
};

export const availableLang=[
  {displayValue: "ENGLISH", machineValue: "en"},
  {displayValue: "GREEK", machineValue: "el"},
  {displayValue: "DEUTSCH", machineValue: "de"},
  {displayValue: "FRENCH", machineValue: "fr"},
  {displayValue: "ITALIAN", machineValue: "it"},
  {displayValue: "PORTUGUESE", machineValue: "pt"},
];
